// extracted by mini-css-extract-plugin
export default {"icons":"EmployeesChart_icons__Ex2Xs","chartTitle":"EmployeesChart_chartTitle__BUvnL","chartLabel":"EmployeesChart_chartLabel__YgZQ3","container":"EmployeesChart_container__kSEAM"};